import React from 'react';
import { Collapse, Typography } from 'antd';
import type { CompactTimelineProjection } from '../../routes/execution/dashboardProjection';

const { Text } = Typography;

type Props = {
  timeline: CompactTimelineProjection;
};

function formatTs(value: string | null): string {
  if (!value) return '';
  try {
    return new Date(value).toLocaleString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return value;
  }
}

export const CompactEventFeed: React.FC<Props> = ({ timeline }) => {
  const { entries } = timeline;
  if (entries.length === 0) {
    return (
      <section className="execution-workspace__section">
        <div className="execution-workspace__section-title">Лента</div>
        <Text className="execution-workspace__muted">Событий пока нет</Text>
      </section>
    );
  }

  return (
    <section className="execution-workspace__section">
      <div className="execution-workspace__section-title">Лента</div>
      {entries.map((item) => (
        <div key={item.key} className="execution-workspace__event">
          <span className="execution-workspace__event-time">{formatTs(item.at)}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <Text
              strong={item.inProgress}
              style={{
                fontSize: 12,
                color: item.kind === 'incident' || item.kind === 'downtime' ? '#cf1322' : undefined
              }}
            >
              {item.label}
            </Text>
            {item.summary && !item.contextLines.includes(item.summary) ? (
              <div className="execution-workspace__muted">{item.summary}</div>
            ) : null}
            {item.contextLines.slice(0, 2).map((line) => (
              <div key={line} className="execution-workspace__muted">
                {line}
              </div>
            ))}
            {item.detailLines.length > 0 ? (
              <Collapse
                ghost
                size="small"
                items={[
                  {
                    key: 'd',
                    label: <span style={{ fontSize: 10 }}>детали</span>,
                    children: item.detailLines.map((line) => <div key={line}>{line}</div>)
                  }
                ]}
              />
            ) : null}
          </div>
        </div>
      ))}
    </section>
  );
};

export default CompactEventFeed;
